import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMfaEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 68,
	height: 64,
	viewBox: "0 0 68 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M34.0013 47.3333V46.6667H7.33464V13.3333L34.0013 30L60.668 13.3333V24.8C63.368 26 65.668 27.8667 67.3346 30.2V6.66667C67.3346 3 64.3346 0 60.668 0H7.33464C3.66797 0 0.667969 3 0.667969 6.66667V46.6667C0.667969 50.3333 3.66797 53.3333 7.33464 53.3333H34.0013V47.3333ZM60.668 6.66667L34.0013 23.3333L7.33464 6.66667H60.668ZM63.3346 43.3333V38.3333C63.3346 33.6667 58.668 30 54.0013 30C49.3346 30 44.668 33.6667 44.668 38.3333V43.3333C42.668 43.3333 40.668 45.3333 40.668 47.3333V59C40.668 61.3333 42.668 63.3333 44.668 63.3333H63.0013C65.3346 63.3333 67.3346 61.3333 67.3346 59.3333V47.6667C67.3346 45.3333 65.3346 43.3333 63.3346 43.3333ZM59.0013 43.3333H49.0013V38.3333C49.0013 35.6667 51.3346 34 54.0013 34C56.668 34 59.0013 35.6667 59.0013 38.3333V43.3333Z",
		fill: "currentColor"
	})
});
export default SvgMfaEmail;
